import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  QuestionCircleOutlined,
  SyncOutlined
} from "@ant-design/icons";
import { DateUtils } from "utils/dateutils";
import { ExtractSpecCardItem } from "../model";
import { Tooltip } from "antd";

export const extractionHistoryStatusCellRenderer = ({
  value,
  data
}: {
  value: "IN_PROGRESS" | "COMPLETED" | "FAILED";
  data: ExtractSpecCardItem;
}) => {
  const baseClassName =
    "text-xs flex flex-wrap items-center h-full p-1 space-x-2";
  const wrapperClassName =
    "flex items-center space-x-1 rounded px-2 py-0.5 border border-solid";

  switch (value) {
    case "IN_PROGRESS":
      return (
        <div className={baseClassName}>
          <div
            className={`${wrapperClassName} bg-ciq-golden-purple-100 border-ciq-golden-purple-400 text-ciq-golden-purple-950`}
          >
            <SyncOutlined className="text-ciq-golden-purple-950" />
            <div>In Progress</div>
          </div>
        </div>
      );
    case "COMPLETED":
      return (
        <div className={baseClassName}>
          <div
            className={`${wrapperClassName} bg-ciq-success-bg border-ciq-success-border text-ciq-success-text`}
          >
            <CheckCircleOutlined className="text-ciq-success-text" />
            <div>Completed</div>
          </div>
        </div>
      );
    case "FAILED":
      return (
        <div className={baseClassName}>
          <div
            className={`${wrapperClassName} bg-ciq-red-50 border-ciq-red-200 text-ciq-error-500`}
          >
            <CloseCircleOutlined className="text-ciq-error-500" />
            <div>Failed</div>
          </div>
          {data.failed_reason && (
            <Tooltip title={data.failed_reason}>
              <QuestionCircleOutlined className="text-ciq-gray-700 hover:text-ciq-gray-700 text-sm cursor-pointer mx-1" />
            </Tooltip>
          )}
        </div>
      );
    default:
      return "-";
  }
};

export const extractionHistoryUploadedOnCellRenderer = ({
  value
}: {
  value: string;
}) => {
  if (!value) return "";

  const date = DateUtils.format(value);
  const time = DateUtils.format(value, "hh:mm A");

  return (
    <div className="flex flex-col text-xs text-ciq-text-900 space-y-0.5">
      <div>{date}</div>
      <div className="text-ciq-text-900 text-opacity-60">{time}</div>
    </div>
  );
};
